import React from 'react'
import { ServicesHero } from './ServicesHero'
import { ServicesList } from './ServicesList'
import { Process } from './Process'
import { WhyChooseUs } from './WhyChooseUs'
import { Industries } from './Industries'
import { ServiceFAQ } from './ServiceFAQ'
import { ServiceCTA } from './ServiceCTA'


export const ServiceSection = () => {
  return (
    <div>
    <ServicesHero />
    <ServicesList />
    <Process/>
    <WhyChooseUs />
    <Industries />
    <ServiceFAQ />
    <ServiceCTA />
    </div>
  )
}
